import React, { useState } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { Text, Icon, Spacer } from 'components/atoms'
import { themeType } from 'types'
import { withTheme } from 'styled-components'

const ModuleCard = ({
  thumbnail,
  description,
  label,
  theme,
  onClick
}) => {
  const [isHover, setHover] = useState(false)

  const handleMouseEnter = () => {
    setHover(true)
  }
  const handleMouseLeave = () => {
    setHover(false)
  }

  return (
    <Module
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      <Module.Preview isHover={isHover}>
        {isHover && (
          <Module.Hover>
            <Icon icon="fal fa-plus" color="#FFF" title="editar" />
          </Module.Hover>
        )}
        {thumbnail ? (
          <img src={thumbnail} alt="preview" />
        ) : (
          <Module.PreviewDefault>
            <Icon
              height={48}
              icon="section"
              color={theme.colors.baseLighterS}
            />
          </Module.PreviewDefault>
        )}
      </Module.Preview>
      <Module.Description>
        <Text modifiers={['base']}>{label}</Text>
        {description && (
          <>
            <Spacer top="xs4" />
            <Text modifiers={['xs', 'base', 'lighter']}>
              {description}
            </Text>
          </>
        )}
      </Module.Description>
    </Module>
  )
}

ModuleCard.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  thumbnail: PropTypes.string,
  theme: themeType.isRequired,
  onClick: PropTypes.func,
}

ModuleCard.defaultProps = {
  label: 'Placeholder',
  description: null,
  thumbnail: null,
  onClick: () => {}
}

const Module = styled.div`
  margin-bottom: ${props => props.theme.spacing.xl1};
  cursor: pointer;
  border: ${props => props.theme.values.borderSize} solid ${props => props.theme.colors.borderLighter};
`
Module.Preview = styled.div`
  position: relative;
  height: 100px;
  overflow: hidden;
  img {
    min-height: 100px;
    width: 100%;
  }
`;

Module.PreviewDefault = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.bgLighterS};
  display: flex;
  align-items: center;
  justify-content: center;
`;

Module.Description = styled.div`
  padding:  ${props => props.theme.spacing.s} ${props => props.theme.spacing.xs};
  padding-bottom:  ${props => props.theme.spacing.sm};
`

Module.Hover = styled.div`
  width: 100%;
  height: 100%;
  padding: ${props => props.theme.spacing.xs};
  position: absolute;
  left: 0;
  top: 0;
  background-color: ${props => props.theme.colors.bgHover};
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
`


export default withTheme(ModuleCard)
